import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";

function Flag(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 16"
  }, props), React.createElement("path", {
    d: "M0 1.11L.322.904A5.239 5.239 0 012.565.042v.01A4.38 4.38 0 013.25 0c.228 0 .46.014.696.042.429.055.869.159 1.319.311.345.11.702.256 1.069.436.18.083.356.163.53.239v-.01a5.07 5.07 0 001.951.352c.727-.007 1.457-.18 2.191-.519l.602-.26 2.035 8.14-.322.208c-1.412.942-2.966 1.16-4.661.655h.01a5.868 5.868 0 01-.457-.146 9.46 9.46 0 01-.789-.342h.01a7.924 7.924 0 00-.623-.26 5.506 5.506 0 00-1.744-.363 5.21 5.21 0 00-2.014.322l1.724 6.925-1.06.27L1.88 8.628l-.01-.01v-.021L0 1.111z"
  }));
}

export { Flag };
//# sourceMappingURL=Flag.js.map